import Reflux from 'reflux';
import ActivityAuditData from 'shared/data/ActivityAudit';

let async = { asyncResult: true },
  ActivityAuditListActions = Reflux.createActions({
    populateForShow: async,
    populateForItemCell: async,
    populateForItemField: async,
    populateForMethodName: async,
    populateForSoftDeletedItemRows: async,
    populateForSoftDeletedColumns: async,
    clear: {},
    refresh: {},
    toggleVisibility: {},
    changePage: {},
  });

ActivityAuditListActions.populateForShow.listenAndPromise(
  ActivityAuditData.getByShowId,
);
ActivityAuditListActions.populateForItemCell.listenAndPromise(
  ActivityAuditData.getByItemCell,
);
ActivityAuditListActions.populateForItemField.listenAndPromise(
  ActivityAuditData.getByItemField,
);
ActivityAuditListActions.populateForMethodName.listenAndPromise(
  ActivityAuditData.getByMethodName,
);
ActivityAuditListActions.populateForSoftDeletedItemRows.listenAndPromise(
  ActivityAuditData.getSoftDeletedItemRows,
);
ActivityAuditListActions.populateForSoftDeletedColumns.listenAndPromise(
  ActivityAuditData.getSoftDeletedColumns,
);

export default ActivityAuditListActions;
